// extracted by mini-css-extract-plugin
export default {"appRedColor":"#821818","whiteColor":"#fff","pageBackgroundColor":"#f5f6fa","cardBoxShadow":"0 4px 20px rgba(0,0,0,.08)"};